import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { VirtualSportQueryKeys } from "./virtualSportQueryKeys";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  getVirtualSportEvent,
  VirtualSportType,
} from "@/api/virtualSport";

import { FeedType } from "@/types/SportsApiResponses";

// Single selected VR match (content pane) — dedicated, decoupled from the shared
// `useSportEventNew`. `sportType` scopes both the cache key and the server's
// market-group lookup.
export const useVirtualSportEvent = (
  providerId: string,
  eventId: string,
  feedType: FeedType,
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [
      VirtualSportQueryKeys.Single,
      sportType,
      locale,
      feedType,
      eventId,
      providerId,
    ],
    enabled: Boolean(eventId) && Boolean(providerId),
    refetchInterval: 3000,
    queryFn: ({ signal }) =>
      getVirtualSportEvent({
        signal,
        params: { lang: locale, id: eventId, feedType, providerId, sportType },
      }),
  });
};
